<template>
    <div>
        <div v-if="isLoaded" class="compiling-shows-container padded-container">
            <img
                :src="landscapePoster"
                id="landscape-poster"
                class="posters orient_lands hide-background"
                alt="&nbsp;" />
            <img
                :src="portraitPoster"
                id="portrait-poster"
                class="posters orient_port hide-background"
                alt="&nbsp;" />

            <div class="text-container">
                <h1 class="title">
                    {{ compilingText }}
                    <div class="dots">
                        <span class="one">.</span>
                        <span class="two">.</span>
                        <span class="three">.</span>
                    </div>
                </h1>
            </div>

            <video
                class="compiling-video-background orient_lands hide-background"
                id="landscape-video-Background"
                loop
                muted
                autoplay
                playsinline>
                <source :src="backgroundVideoLandscape" type="video/mp4" />
            </video>

            <video
                class="compiling-video-background orient_port hide-background"
                id="portrait-video-Background"
                loop
                muted
                autoplay
                playsinline>
                <source :src="backgroundVideoPortrait" type="video/mp4" />
            </video>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import HttpService from 'services/HttpServiceBasic';
    import { SHOWPICKER_WATCHLIST_ENABLED } from 'helpers/featureConstants';
    const LANDSCAPE_IMG_ATTR = 'primary_background_landscape';
    const PORTRRAIT_IMG_ATTR = 'primary_background_portrait';
    const VIDEO_BACKGROUND_LANDSCAPE = 'video_background_landscape';
    const VIDEO_BACKGROUND_PORTRAIT = 'video_background_portrait';
    const HEADING_ATTR = 'heading';
    const IMAGE_HOST = CBS.Registry.imageHost || 'https://wwwimage-secure.cbsstatic.com';

    export default {
        name: 'CompilingShows',

        data() {
            return {
                noRedirect: false,
                imageHost: CBS.Registry.imageHost,
            };
        },

        computed: {
            ...mapGetters([
                'showspicker/compilingPageAttributes',
                'showspicker/selectedShows',
                'showspicker/inSignupProcess',
            ]),

            isLoaded() {
                return this['showspicker/compilingPageAttributes'] !== null;
            },

            backgroundVideoLandscape() {
                const attribute = this.getPageAttribute(VIDEO_BACKGROUND_LANDSCAPE);

                if (attribute.length > 0) {
                    return attribute;
                } else {
                    return '';
                }
            },

            backgroundVideoPortrait() {
                const attribute = this.getPageAttribute(VIDEO_BACKGROUND_PORTRAIT);

                if (attribute.length > 0) {
                    return attribute;
                } else {
                    return '';
                }
            },

            landscapePoster() {
                const attribute = this.getPageAttribute(LANDSCAPE_IMG_ATTR);
                if (attribute.length > 0) {
                    return `${IMAGE_HOST}/base/${attribute}`;
                }
            },
            portraitPoster() {
                const attribute = this.getPageAttribute(PORTRRAIT_IMG_ATTR);
                if (attribute.length > 0) {
                    return `${IMAGE_HOST}/base/${attribute}`;
                }
            },
            compilingText() {
                let heading = this.getPageAttribute(HEADING_ATTR);
                return heading;
            },

            inSignUp() {
                return this['showspicker/inSignupProcess'] ? true : false;
            },
        },

        methods: {
            getPageAttribute(attributeKey) {
                const attrs = this['showspicker/compilingPageAttributes'];

                if (attrs === null || attrs.length < 1) {
                    return '';
                }

                let attrKeys = Object.keys(attrs[0]);
                if (attrKeys.includes(attributeKey)) {
                    return attrs[0][attributeKey];
                } else {
                    return '';
                }
            },

            postShows() {
                if (this.noRedirect) {
                    return false;
                }
                let geturl = `/shows/picker/xhr/showids/${this['showspicker/selectedShows'].join(
                    ',',
                )}/`;

                this.httpService.doGet(geturl).finally(() => {
                    setTimeout(() => {
                        if (CBS.Registry.Features[SHOWPICKER_WATCHLIST_ENABLED] === true) {
                            this.addColdStartPickerSelectedShowsToMylist().finally(() => {
                                this.redirectAfterColdStart();
                            });
                        } else {
                            this.redirectAfterColdStart();
                        }
                    }, 4000);
                });
            },

            redirectAfterColdStart() {
                if (this.inSignUp === true) {
                    window.location.href = this.$store.getters['flow/destinationUrl'];
                } else {
                    this.$router.replace({ name: 'WhosWatching' });
                }
            },

            addColdStartPickerSelectedShowsToMylist() {

                let posturl = `/shows/picker/xhr/showids/watchlist/`;
                const selectedShowIds = this['showspicker/selectedShows'];
                const params = { showIds: selectedShowIds };

                return this.httpService.doPost(posturl, params).catch((error) => {
                    console.warn(error);
                });
            },

            loadBackground() {
                const landscapeVideoBackground = document.getElementById(
                    'landscape-video-Background',
                );
                const portraitVideoBackground = document.getElementById(
                    'portrait-video-Background',
                );
                const landscapePoster = document.getElementById('landscape-poster');
                const portraitPoster = document.getElementById('portrait-poster');

                landscapeVideoBackground.addEventListener('canplaythrough', function () {
                    landscapeVideoBackground.classList.remove('hide-background');
                });

                portraitVideoBackground.addEventListener('canplaythrough', function () {
                    portraitVideoBackground.classList.remove('hide-background');
                });

                landscapeVideoBackground.addEventListener('stalled', function () {
                    landscapePoster.classList.remove('hide-background');
                });

                portraitVideoBackground.addEventListener('stalled', function () {
                    portraitPoster.classList.remove('hide-background');
                });

                landscapeVideoBackground.addEventListener('error', function () {
                    landscapePoster.classList.remove('hide-background');
                });

                portraitVideoBackground.addEventListener('error', function () {
                    portraitPoster.classList.remove('hide-background');
                });
            },
        },

        beforeMount() {
            // If there's no page attributes loaded
            if (this['showspicker/compilingPageAttributes'] === null) {
                this.$store.dispatch('showspicker/loadCompilingPageAttributes');
            }
        },

        mounted() {
            this.postShows();
            this.loadBackground();
        },

        created() {
            this.httpService = new HttpService();
            this.httpService.regionBaseUrl = CBS.Registry.region.prefix;

            if (this.$route.query.hasOwnProperty('no_redirect')) {
                this.noRedirect = true;
            }
        },
    };
</script>
